import { Component, OnInit , CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { State } from '@app/core/ngrx/reducers';
import { paymentSelectors } from '@app/core/ngrx/selectors';
import { AlertController, LoadingController, ModalController, NavController } from '@ionic/angular';
import { select, Store } from '@ngrx/store';
import { PaymentNotifyPopupComponent } from '../payment-notify-popup/payment-notify-popup.component';
import { flatMap } from 'rxjs/operators';
import { QueryService } from '@app/core/graphql/query/query.service';
import { of } from 'rxjs';
import PaymentApplication from '@Interfaces/PaymentApplication';
import { Angulartics2GoogleTagManager } from 'angulartics2';
import { ActivatedRoute } from '@angular/router';
import { ModalService } from '@app/core/services/modal/modal.service';
import { PaymentService } from '@app/core/services/payment/payment.service';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { faStethoscope } from '@fortawesome/pro-regular-svg-icons';
import { faBookMedical, faBriefcaseMedical, faLaptopMedical, faNotesMedical, faTooth, faUserNurse, faLink } from '@fortawesome/pro-solid-svg-icons';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ImgPipe } from '@app/shared/pipes/img/img.pipe';

@Component({
    selector: 'app-application-summary',
    templateUrl: './payment-application-list.component.html',
    styleUrls: ['./payment-application-list.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule, FontAwesomeModule, ImgPipe],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class PaymentApplicationDetailsComponent implements OnInit {
    constructor(
        private store: Store<State>,
        private route: ActivatedRoute,
        private navController: NavController,
        private alertController: AlertController,
        private loadingController: LoadingController,
        private modalCtrl: ModalController,
        private queryService: QueryService,
        private paymentService: PaymentService,
        private angulartics2GoogleTagManager: Angulartics2GoogleTagManager
    ) {}

    testpt: string = 'first-payment';

    application$ = this.store.pipe(select(paymentSelectors.getPayableApplication));
    //
    applicationList$ = this.store.select(paymentSelectors.getPaymentList);
    //
    applicationSelectList$ = this.store.select(paymentSelectors.getPaymentSelectList);
    //
    $applicationCart = this.store.select(paymentSelectors.getPaymentCart);
    //
    public PaymentCartList: any[] = [];
    //
    public PaymentList: any[] = [];
    //
    isDisabled: boolean = true;
    // update the model application list
    listUpdater$ = this.store.select(paymentSelectors.getPaymentListUpdate);
    //

    faChevronRight = faChevronRight;
    iconOfiti = faLink;

    restrictMonthYearArray;

    cartStatus = {
        length: 0,
        fullPaymentLength: 0,
        finalPaymentLength: 0,
    };

    loadingPayment: boolean = false;

    ngOnInit() {
        this.cartListener();
    }

    setIcons(type): void {
        switch (type) {
            case 'Hands-On':
                this.iconOfiti = faStethoscope;
                break;
            case 'Observership':
                this.iconOfiti = faNotesMedical;
                break;
            case 'Nursing':
                this.iconOfiti = faUserNurse;
                break;
            case 'Dentistry':
                this.iconOfiti = faTooth;
                break;
            case 'Virtual':
                this.iconOfiti = faLaptopMedical;
                break;
            case 'Virtual Pre-med shadowing':
                this.iconOfiti = faLaptopMedical;
                break;
            case 'Research':
                this.iconOfiti = faBookMedical;
                break;
            case 'Pre-med shadowing':
                this.iconOfiti = faBriefcaseMedical;
                break;
            default:
                this.iconOfiti = faNotesMedical;
                break;
        }
    }

    // used for index tracking
    trackByIndex = (index: number): number => index;

    cartListener() {
        //
        this.applicationList$.subscribe((response: Array<PaymentApplication>) => {
            // this is the template bound ngmodel list
            this.PaymentList = response.map((i) => {
                return { ...i };
            });
        });

        // create payment list from existing cart items
        this.$applicationCart.subscribe((response: Array<PaymentApplication>) => {
            this.PaymentCartList = response.map((i) => {
                return { ...i };
            });
        });

        // if NP type, we want to disable the deposit button

        // CART UPDATE LISTENER
        // used to update ng model value array
        // and the copy state not bound to ngmodel but use in components (like coupon)
        this.listUpdater$
            .pipe(
                flatMap((response: Array<string>) => {
                    // array in here contains application ids for updating
                    // as of now we do not need
                    if (response.length > 0) {
                        return this.queryService.payableApplication();
                    } else {
                        return of(false);
                    }
                })
            )
            .subscribe((response: any) => {
                if (response) {
                    // list of updated payable applications
                    let NewSourceList = response.data.payableApplications.map((a: PaymentApplication) => {
                        return { ...a };
                    });
                    //
                    let NewList_ = [];
                    //
                    let NewCartList = [];
                    //

                    for (let i = 0; i < this.PaymentCartList.length; i++) {
                        // for each item in the current cart
                        let CurrentItem = { ...this.PaymentCartList[i] };
                        // find its updated equal in the new list
                        let NewItem: PaymentApplication = NewSourceList.find((item: PaymentApplication) => item.id === CurrentItem.id);
                        // and create new update with query value and current cart value
                        NewCartList.push({
                            ...CurrentItem,
                            ...NewItem,
                            // override next state fields with some current selections
                            isChecked: CurrentItem.isChecked, // local boolean fields keep the same
                            malpracticeChecked: CurrentItem.malpracticeChecked,
                            switchProtectionChecked: CurrentItem.switchProtectionChecked,
                            malpracticeAddonSubtotal: CurrentItem.malpracticeChecked ? CurrentItem.malpracticeAddonSubtotal : 0,
                            switchProtectionAddonSubtotal: CurrentItem.switchProtectionChecked ? CurrentItem.switchProtectionAddonPrice : 0,
                            addons: CurrentItem.addons,
                            paymentType: CurrentItem.paymentType,
                            fullSubtotalPrice: NewItem.fullSubtotalPrice,
                            finalSubtotalPrice: NewItem.finalSubtotalPrice,
                            firstSubtotalPrice: NewItem.firstSubtotalPrice,
                        });
                    }
                    //
                    for (let i = 0; i < this.PaymentList.length; i++) {
                        // for each item in the current model list
                        let CurrentItem = { ...this.PaymentList[i] };
                        // find its updated equal in the new list
                        let NewItem = NewSourceList.find((item: any) => item.id === CurrentItem.id);
                        // and create new update with query value and current cart value
                        NewList_.push({
                            ...CurrentItem,
                            ...NewItem,
                            isChecked: CurrentItem.isChecked, // local boolean fields keep the same
                            malpracticeChecked: CurrentItem.malpracticeChecked,
                            switchProtectionChecked: CurrentItem.switchProtectionChecked,
                            addons: CurrentItem.addons,
                            paymentType: CurrentItem.paymentType,
                        });
                    }
                    //
                    //
                    // this.PaymentCartList = NewCartList.map((a: any) => {
                    //     return { ...a };
                    // });
                    //
                    // this.PaymentList = NewList.map((a: any) => { return { ... a }});
                    //
                    this.paymentService.updateCurrentCart(
                        NewCartList.map((application) => {
                            return { ...application };
                        })
                    );
                    //
                    this.paymentService.updateApplicationPaymentList = NewList_.map((application) => {
                        return { ...application };
                    });
                }
            });
    }
    // used for viewing program
    viewProgram(id: string) {
        //
        this.navController.navigateForward([`/program/${id}`]);
    }

    /**
     * @description main fnc: editing the payment cart
     * @param event
     * @param application
     */
    // used for editing payment cart list on the right side of the screen
    async togglePaymentState(event: any, application: PaymentApplication) {
        //
        let TempList: PaymentApplication[] = [];
        //
        //
        //
        // console.log('PAYMENT CART LIST: ', this.PaymentCartList);
        // console.log('PENDING WIRE??', application);
        if (application.pendingWiretransfer) {
            const deleted = await this.confirmWiretransferDelete();
            if (deleted.data) {
                await this.paymentService.userRemoveWire(application.id);
                application.pendingWiretransfer = false;
            } else {
                application.isChecked = false;
                return false;
            }
        }

        if (this.PaymentCartList.length === 0) {
            //
            application.isChecked = true;
            TempList.push({ ...application });

            // add first item to cart
            let NextCartState = TempList.map((application) => {
                return {
                    ...application,
                    displayPaymentType:
                        application.paymentType === 'first-payment'
                            ? 'Deposit Payment'
                            : application.paymentType === 'final-payment'
                            ? 'Final Payment'
                            : 'Full Payment',
                    location: application.city + ', ' + application.state,
                    image: application.program.image,
                    addons: [],
                    malpracticeAddonSubtotal: 0,
                    switchProtectionAddonSubtotal: 0,
                };
            });

            //
            this.paymentService.updateCurrentCart(NextCartState);
        } else {
            // remove or add
            //
            // new application index if exist or not

            let index = this.PaymentCartList.findIndex((item: any) => {
                return item.id === application.id;
            });
            //
            if (index >= 0) {
                // remove application from the cart list
                //
                // remove item from the cart list
                this.PaymentCartList.splice(index, 1);
                application.isChecked = false;
                application.malpracticeChecked = false;
                application.switchProtectionChecked = false;

                this.cartStatus.length = this.PaymentCartList.length;
                this.cartStatus.fullPaymentLength = [...this.PaymentCartList].filter((i) => i.paymentType === 'full-payment').length;
                this.cartStatus.finalPaymentLength = [...this.PaymentCartList].filter((i) => i.paymentType === 'final-payment').length;
                //
                this.loadingPayment = true;
                //
                this.route.queryParams
                    .pipe((params: any) => {
                        if (params.chainid) {
                            return this.queryService.updateCartFinal(params.chainid, this.PaymentCartList.length);
                        } else {
                            return this.queryService.updateCartFinal(params.applicationid, this.cartStatus);
                        }
                    })
                    .subscribe(
                        (cart: any) => {
                            const newItems = cart.data.payableApplications;
                            //
                            TempList = this.PaymentCartList.map((i: PaymentApplication) => {
                                if (newItems.indexOf((a) => a.id === i.id)) {
                                    const index = newItems.findIndex((b) => b.id === i.id);

                                    return {
                                        ...i,
                                        finalSubtotalPrice: newItems[index].finalSubtotalPrice,
                                        fullSubtotalPrice: newItems[index].fullSubtotalPrice,
                                    };
                                } else {
                                    return { ...i };
                                }
                            });
                            //
                            this.paymentService.updateCurrentCart(TempList);
                            this.loadingPayment = false;
                        },
                        (err) => {
                            this.loadingPayment = false;
                        }
                    );

                //
            } else {
                application.isChecked = true;

                // add this application to the cart list
                // TempList.push({ ... application });
                // add first item to cart
                this.PaymentCartList.push({
                    ...application,
                    displayPaymentType:
                        application.paymentType === 'first-payment'
                            ? 'Deposit Payment'
                            : application.paymentType === 'final-payment'
                            ? 'Final Payment'
                            : 'Full Payment',
                    location: application.city + ', ' + application.state,
                    addons: [], // empty addons to start
                    image: application.program.image,
                    malpracticeAddonSubtotal: 0,
                    switchProtectionAddonSubtotal: 0,
                });

                this.cartStatus.length = this.PaymentCartList.length;
                this.cartStatus.fullPaymentLength = [...this.PaymentCartList].filter((i) => i.paymentType === 'full-payment').length;
                this.cartStatus.finalPaymentLength = [...this.PaymentCartList].filter((i) => i.paymentType === 'final-payment').length;
                //
                // let NextCartState = this.PaymentCartList.map((i: PaymentApplication) => {
                //     return { ...i };
                // });

                // console.log(this.PaymentCartList);
                // SET VIEWABLE PAYMENT CART LIST
                //
                this.loadingPayment = true;
                //
                this.route.queryParams
                    .pipe((params: any) => {
                        if (params.chainid) {
                            return this.queryService.updateCartFinal(params.chainid, this.cartStatus);
                        } else {
                            return this.queryService.updateCartFinal(params.applicationid, this.cartStatus);
                        }
                    })
                    .subscribe(
                        (cart: any) => {
                            const newItems = cart.data.payableApplications;

                            const list = this.PaymentCartList.map((i: PaymentApplication) => {
                                if (newItems.indexOf((a) => a.id === i.id)) {
                                    const index = newItems.findIndex((b) => b.id === i.id);

                                    return {
                                        ...i,
                                        finalSubtotalPrice: newItems[index].finalSubtotalPrice,
                                        fullSubtotalPrice: newItems[index].fullSubtotalPrice,
                                    };
                                } else {
                                    return { ...i };
                                }
                            });

                            this.paymentService.updateCurrentCart(list);
                            this.loadingPayment = false;
                        },
                        (err) => {
                            this.loadingPayment = false;
                        }
                    );

                // Angulartics pageview for the selected application
                this.angulartics2GoogleTagManager.pageTrack(`/payment?applicationid=${application.id}`);
            }
        }
    }

    /**
     * @function btnSelectApplicationOverlay
     * @param event
     * @param application
     */
    btnSelectApplicationOverlay(event: any, application: PaymentApplication) {
        // prevent mouseclick propogation when clicking on the overlay
        event.stopPropagation();

        // Angulartics pageview for the selected application
        this.angulartics2GoogleTagManager.pageTrack(`/payment?applicationid=${application.id}`);

        // call editPaymentCart
        this.editPaymentCart(event, application);
    }

    /**
     * @description main fnc: editing the payment cart
     * @param event
     * @param application
     */
    // used for editing payment cart list on the right side of the screen
    async editPaymentCart(event: any, application: PaymentApplication) {
        try {
            var logEventValue = {
                applicationid: application.id,
                startdate: application.startdate,
            };

            // Angulartics Event: paymentApplicationDetailsCheckboxClick
            this.angulartics2GoogleTagManager.eventTrack('paymentApplicationDetailsCheckboxClick', {
                category: 'Payments',
                label: JSON.stringify(logEventValue),
            });

            // validate application state
            const loading = await this.loadingController.create({
                // cssClass: 'my-custom-class',
                message: 'Please wait...',
                // duration: 2000
            });
            //
            await loading.present();

            // build the restrictMonthYearArray first
            this.restrictMonthYearArray = [];
            this.PaymentCartList.forEach((item) => {
                if (item.id !== application.id) {
                    const dateSplit = item.startdate.split('-');
                    const dateMonth = Number(dateSplit[1]);
                    this.restrictMonthYearArray.push({
                        date: dateMonth.toString() + new Date(item.startdate).getFullYear().toString(),
                    });
                    this.restrictMonthYearArray.push({ id: item.id });
                }
            });

            const appStatus = await this.ApplicationPaymentNotReady(
                event,
                application.states,
                application.id,
                application.program.preapprovalrequired,
                application.pastDeadline
            );

            // restrict application start dates
            var appStart = await this.ApplicationDateCartControl(event, application);

            if (appStatus.success === false) {
                await loading.dismiss();
            } else if (!appStatus) {
                await loading.dismiss();
            } else if (!appStart) {
                await loading.dismiss();
            } else {
                this.togglePaymentState(event, application);
                await loading.dismiss();
            }
        } catch (error) {
            this.angulartics2GoogleTagManager.eventTrack('paymentApplicationDetailsCheckboxClick', {
                category: 'Payments',
                label: JSON.stringify({ ...logEventValue, error }),
            });
        }
    }

    /**
     * @description when addons are clicked
     * @param event name of the addon selected
     * @param application
     */
    addonClicked(event: string, application: PaymentApplication) {
        // Angulartics Event: paymentApplicationDetailsAddonCheckboxClick
        this.angulartics2GoogleTagManager.eventTrack('paymentApplicationDetailsAddonCheckboxClick', { category: 'Payments', label: JSON.stringify(event) });

        //
        // get the addon this user selected
        const selectedAddon = application.paymentApplicationAddons.find((addOn: any) => {
            return addOn.name === event;
        });

        //
        this.paymentService.updateCartWithAddons(selectedAddon, application);
    }

    /**
     * @description event for when a segment is clicked
     * @param event
     * @param application
     */
    segmentChanged(event: any, application: PaymentApplication) {
        // Angulartics Event: paymentApplicationDetailsSegmentBtnClick
        this.angulartics2GoogleTagManager.eventTrack('paymentApplicationDetailsSegmentBtnClick', { category: 'Payments', label: String(event.detail.value) });

        //
        //
        let TempList = this.PaymentCartList.map((i) => {
            return { ...i };
        });
        //
        let index = this.PaymentCartList.findIndex((item: any) => {
            return item.id === application.id;
        });

        // card display payment type
        let displayPaymentType: string;
        //
        if (application.paymentType === 'first-payment') {
            displayPaymentType = 'Deposit Payment';
        } else if (application.paymentType === 'full-payment') {
            displayPaymentType = 'Full Payment';
        } else {
            displayPaymentType = 'Final Payment';
        }
        //

        let switchProtection: boolean;
        let addons: any[] = [];
        let switchProtectionAddonSubtotal: number = 0;
        let malpracticeChecked: boolean;
        let malpracticeAddonSubtotal: number = 0;
        // let subtotalPrice: number;
        // // check for properties by payment type and calculate pricing
        if (application.paymentType === 'first-payment') {
            // hard blank malpractice when first payment
            // malpracticeChecked = false;
            // malpracticeAddonSubtotal = 0;
            // application.malpracticeChecked = false;
            // check for switch protection existing
            if (application.switchProtectionChecked) {
                addons.push({
                    name: 'switchprotection',
                    price: application.switchProtectionAddonPrice,
                });
                switchProtection = true;
                switchProtectionAddonSubtotal = application.switchProtectionAddonPrice;
            }
            if (application.malpracticeChecked) {
                malpracticeChecked = true;
                addons.push({
                    name: 'malpractice',
                    price: application.malpracticeAddonPrice,
                });
                malpracticeAddonSubtotal = application.malpracticeAddonPrice;
            }
        } else if (application.paymentType === 'final-payment') {
            switchProtection = false;
            switchProtectionAddonSubtotal = 0;
            if (application.malpracticeChecked) {
                addons.push({
                    name: 'malpractice',
                    price: application.malpracticeAddonPrice,
                });
                malpracticeAddonSubtotal = application.malpracticeAddonPrice;
            }
        } else {
            // full payment keep malpractice checked
            if (application.malpracticeChecked) {
                malpracticeChecked = true;
                addons.push({
                    name: 'malpractice',
                    price: application.malpracticeAddonPrice,
                });
                malpracticeAddonSubtotal = application.malpracticeAddonPrice;
            }
            // full payment keep switch protection checked
            if (application.switchProtectionChecked) {
                addons.push({
                    name: 'switchprotection',
                    price: application.switchProtectionAddonPrice,
                });
                switchProtection = true;
                switchProtectionAddonSubtotal = application.switchProtectionAddonPrice;
            }
        }

        //
        TempList.splice(index, 1, {
            ...application,
            addons: addons,
            displayPaymentType: displayPaymentType,
            location: application.city + ', ' + application.state,
            image: application.program.image,
            malpracticeChecked: malpracticeChecked,
            switchProtectionChecked: switchProtection,
            switchProtectionAddonSubtotal: switchProtectionAddonSubtotal,
            malpracticeAddonSubtotal: malpracticeAddonSubtotal,
        });

        //
        this.PaymentCartList = TempList.map((application: PaymentApplication) => {
            return { ...application };
        });

        this.cartStatus.length = this.PaymentCartList.length;
        this.cartStatus.fullPaymentLength = [...this.PaymentCartList].filter((i) => i.paymentType === 'full-payment').length;
        this.cartStatus.finalPaymentLength = [...this.PaymentCartList].filter((i) => i.paymentType === 'final-payment').length;

        this.route.queryParams
            .pipe((params: any) => {
                if (params.chainid) {
                    return this.queryService.updateCartFinal(params.chainid, this.PaymentCartList.length);
                } else {
                    return this.queryService.updateCartFinal(params.applicationid, this.cartStatus);
                }
            })
            .subscribe((cart: any) => {
                const newItems = cart.data.payableApplications;
                //
                TempList = this.PaymentCartList.map((i: PaymentApplication) => {
                    if (newItems.indexOf((a) => a.id === i.id)) {
                        const index = newItems.findIndex((b) => b.id === i.id);

                        return {
                            ...i,
                            finalSubtotalPrice: newItems[index].finalSubtotalPrice,
                            fullSubtotalPrice: newItems[index].fullSubtotalPrice,
                        };
                    } else {
                        return { ...i };
                    }
                });
                //
                this.paymentService.updateCurrentCart(TempList);
            });
    }

    async addonLearnMoreModal(addonObject: any) {
        let addonText: string;
        let addonSubText: string;
        let type: string = addonObject.name;
        if (addonObject.name === 'malpractice') {
            addonText = "The rotation you've selected involves direct patient contact. AMO requires malpractice insurance to attend these rotations.";
            addonSubText = 'You can pay now or after your reservation to be added to the AMO plan. Otherwise you can find your own insurance from a 3rd party.';
        } else {
            addonText = 'Switch Protection allows you to switch to another rotation or another time once without paying the normal switch fee of $500 USD.';
            addonSubText = 'Switch protection gives you the flexibility to change your plans easily if something comes up or your preferences change.';
        }
        // Angulartics Event: paymentApplicationDetailsAddonLearnMoreBtnClick
        this.angulartics2GoogleTagManager.eventTrack('paymentApplicationDetailsAddonLearnMoreBtnClick', { category: 'Payments', label: 'malpractice' });

        const addonLearnMore = await this.modalCtrl.create({
            component: PaymentNotifyPopupComponent,
            backdropDismiss: false,
            cssClass: 'payment-notify-popup',
            componentProps: {
                icon: {
                    name: 'alert',
                    color: 'secondary',
                    class: 'alert-icon',
                    size: 'large',
                },
                messages: [
                    {
                        text: addonText,
                        type: 'string',
                        class: 'text-center bold-text black-text',
                    },
                    {
                        text: addonSubText,
                        type: 'string',
                        class: 'text-center black-text',
                    },
                ],
                buttons: [
                    {
                        id: 'addonLearnMoreModalDismissBtn',
                        type: 'dismiss',
                        text: 'Got It',
                        fill: 'solid',
                        color: 'secondary',
                    },
                ],
                application_id: '',
                type: type,
            },
        });

        addonLearnMore.onDidDismiss().then((modalData: any) => {
            if (modalData !== null) {
                this.angulartics2GoogleTagManager.eventTrack('addonLearnMoreModalDismissBtnClick', { category: 'Payments', label: addonObject.name });
            }
        });

        //
        //
        await addonLearnMore.present();
        return { success: false };
        //
    }

    /**
     * @function ApplicationPaymentNotReady
     *
     * @param evnt
     * @param applicationState
     * @param preapprovalRequired
     * @param applicationId
     */
    async ApplicationPaymentNotReady(evnt: any, applicationState: any, applicationId: string, preapprovalRequired?: boolean, pastDeadline?: boolean) {
        // stop event propogation
        evnt.stopPropagation();

        var logEventValue = {
            applicationid: applicationId,
            state: applicationState,
        };

        // Angulartics Event: ApplicationPaymentNotReadyModalOpen
        this.angulartics2GoogleTagManager.eventTrack('ApplicationPaymentNotReadyModalOpen', { category: 'Payments', label: JSON.stringify(logEventValue) });

        if ((applicationState === 'Pending' && preapprovalRequired === false)) {
            const ApplicationPaymentNotReadyModal = await this.modalCtrl.create({
                component: PaymentNotifyPopupComponent,
                backdropDismiss: false,
                cssClass: 'payment-notify-popup',
                componentProps: {
                    icon: {
                        name: 'alert',
                        color: 'primary',
                        class: 'alert-icon',
                        size: 'large',
                    },
                    messages: [
                        {
                            text:
                                applicationState === 'Pending' && preapprovalRequired === false
                                    ? 'Application Pending'
                                    : 'Application Pending. You are still awaiting acceptance for this rotation.',
                            type: 'string',
                            class: 'text-center bold-text black-text',
                        },
                        preapprovalRequired
                            ? {
                                  text: '<h4>Please upload your documents to <span class="bold-text orange">Verify Eligibility</span> in your application.</h4>',
                                  type: 'html',
                                  class: 'black-text text-center',
                              }
                            : {
                                  text: '<h4>Before you can hold your seat and complete the rest of your application, you must reserve your rotation by making a payment.</h4>',
                                  type: 'html',
                                  class: 'black-text text-center',
                              },
                    ],
                    buttons: [
                        {
                            id: 'goToVerifyEligibilityCancelBtn',
                            type: 'dismiss',
                            text: 'Not Now',
                            fill: 'outline',
                            color: 'primary',
                        },
                        preapprovalRequired
                            ? {
                                  id: 'goToVerifyEligibilitySubmitBtn',
                                  type: 'submit',
                                  text: 'Go To Verify Eligibility',
                                  fill: 'solid',
                                  color: 'primary',
                              }
                            : {
                                  id: 'goToVerifyEligibilitySubmitBtn',
                                  type: 'submit',
                                  text: 'Pay and Reserve',
                                  fill: 'solid',
                                  color: 'primary',
                              },
                    ],
                    application_id: applicationId,
                },
            });

            ApplicationPaymentNotReadyModal.onDidDismiss().then((modalData: any) => {
                if (modalData !== null) {
                    if (modalData.data.success) {
                        // Angulartice Event: goToVerifyEligibilitySubmitBtnClick
                        this.angulartics2GoogleTagManager.eventTrack('goToVerifyEligibilitySubmitBtnClick', {
                            category: 'Payments',
                            label: JSON.stringify(logEventValue),
                        });
                        if (preapprovalRequired) {
                            this.navController.navigateRoot(['/application/' + applicationId]);
                        } else {
                            this.navController.navigateRoot(['/payment'], { queryParams: { applicationid: applicationId, type: 'booking' } });
                        }
                    } else {
                        // Angulartics Event: goToVerifyEligibilityCancelBtnClick
                        this.angulartics2GoogleTagManager.eventTrack('goToVerifyEligibilityCancelBtnClick', {
                            category: 'Payments',
                            label: JSON.stringify(logEventValue),
                        });
                        return;
                    }
                }
            });

            await ApplicationPaymentNotReadyModal.present();
            return { success: false };
        } else if (pastDeadline) {
            const ApplicationPaymentNotReadyModal = await this.modalCtrl.create({
                component: PaymentNotifyPopupComponent,
                backdropDismiss: false,
                cssClass: 'payment-notify-popup',
                componentProps: {
                    icon: {
                        name: 'alert',
                        color: 'primary',
                        class: 'alert-icon',
                        size: 'large',
                    },
                    messages: [
                        {
                            text: 'Application past deadline date.',
                            type: 'string',
                            class: 'text-center bold-text black-text',
                        },
                        {
                            text: '<h4>Please contact your advisor.</h4>',
                            type: 'html',
                            class: 'black-text text-center',
                        },
                    ],
                    buttons: [
                        {
                            id: 'goToVerifyEligibilityCancelBtn',
                            type: 'dismiss',
                            text: 'OK',
                            fill: 'outline',
                            color: 'primary',
                        },
                    ],
                    application_id: applicationId,
                },
            });

            ApplicationPaymentNotReadyModal.onDidDismiss().then((modalData: any) => {
                if (modalData !== null) {
                    if (modalData.data.success) {
                        // Angulartice Event: goToVerifyEligibilitySubmitBtnClick
                        this.angulartics2GoogleTagManager.eventTrack('goToVerifyEligibilitySubmitBtnClick', {
                            category: 'Payments',
                            label: JSON.stringify(logEventValue),
                        });
                        this.navController.navigateRoot(['/application/' + applicationId]);
                    } else {
                        // Angulartics Event: goToVerifyEligibilityCancelBtnClick
                        this.angulartics2GoogleTagManager.eventTrack('goToVerifyEligibilityCancelBtnClick', {
                            category: 'Payments',
                            label: JSON.stringify(logEventValue),
                        });
                        return;
                    }
                }
            });

            await ApplicationPaymentNotReadyModal.present();
            return { success: false };
        } else {
            return { success: true };
        }
    }

    viewWireDetails() {
        this.navController.navigateForward(['/wire-transfer-details']);
    }

    async confirmWiretransferDelete() {
        //
        // ANgulartics Event: paymentApplicationDetailsAddonLearnMoreBtnClick
        // this.angulartics2GoogleTagManager.eventTrack('paymentApplicationDetailsAddonLearnMoreBtnClick', {  category: 'Payments', label: 'malpractice', });

        const confirmWiretransferDelete = await this.modalCtrl.create({
            component: PaymentNotifyPopupComponent,
            backdropDismiss: false,
            cssClass: 'payment-notify-popup',
            componentProps: {
                icon: {
                    name: 'alert',
                    color: 'primary',
                    class: 'alert-icon',
                    size: 'large',
                },
                messages: [
                    {
                        text: 'The application you have selected has a pending wire transfer payment.',
                        type: 'string',
                        class: 'text-center bold-text black-text',
                    },
                    {
                        text: 'Would you like to clear your previous wire transfer request?',
                        type: 'string',
                        class: 'black-text text-center',
                    },
                ],
                buttons: [
                    {
                        id: 'confirmWireRemoveBtn',
                        type: 'confirm-delete',
                        text: 'Clear previous wire transfer request',
                        fill: 'solid',
                        color: 'primary',
                    },
                    {
                        id: 'confirmViewPendingWireBtn',
                        type: 'view-pending-wire',
                        text: 'View pending wiretransfer request',
                        fill: 'clear',
                        color: 'primary',
                    },
                    {
                        id: 'confirmCancelPendingWireBtn',
                        type: 'cancel-select',
                        text: 'Unselect application',
                        fill: 'clear',
                        color: 'primary',
                    },
                ],
                application_id: '',
            },
        });

        await confirmWiretransferDelete.present();
        return await confirmWiretransferDelete.onDidDismiss();
        //
    }

    viewApplicationDetails(id: string) {
        this.angulartics2GoogleTagManager.eventTrack('Payment Page View Program Details Button Click', {
            category: 'Payments',
            label: 'Navigate Forward ' + id,
        });
        this.navController.navigateForward([`/application/${id}`]);
    }

    appliationPreventZeroSubtotal(application: PaymentApplication) {
        return new Promise((resolve, reject) => {
            if (application.paymentType === 'final-payment' && application.finalSubtotalPrice <= 0) {
                resolve(false);
            } else {
                resolve(true);
            }
        });
    }

    async ApplicationDateCartControl(event: any, application: PaymentApplication) {
        //
        event.stopPropagation();
        // empty restrictions doors are open!
        if (this.restrictMonthYearArray.length === 0) {
            return true;
        } else {
            // control date is latest application selected start date
            const dateSplit = application.startdate.split('-');
            const dateMonth = Number(dateSplit[1]);

            let controlDate = {
                date: dateMonth.toString() + new Date(application.startdate).getFullYear().toString(),
            };

            // does this date exist in our control list
            let flagDate = this.restrictMonthYearArray.find((item) => item.date === controlDate.date);
            // does this application eixst in our control list
            let flagID = this.restrictMonthYearArray.find((item) => item.id === application.id);

            // if date exists but not application we restrict paying for two applications for same month
            if (flagDate && !flagID) {
                // DENY AND ALERT
                application.isChecked = false;
                let duplicateAlert = await this.alertController.create({
                    message: 'Application with identical start date already in cart.',
                });
                await duplicateAlert.present();
                return false;
            } else if (!flagID && !flagDate) {
                // adding totally new application that does not exist
                this.restrictMonthYearArray.push(controlDate);
                this.restrictMonthYearArray.push({ id: application.id });
                return true;
            } else if (flagDate && flagID) {
                // need to remove id and date from restrictions
                // remove item from cart
                let nextRestirctionList = this.restrictMonthYearArray
                    .filter((item: any) => item.id !== application.id)
                    .filter((item: any) => item.date !== controlDate.date);
                //
                this.restrictMonthYearArray = nextRestirctionList.map((item: any) => item);
                //
                return true;
            }
        }
    }
}
// reducer user for sum price
const reducer = (acc: number, curr: number) => acc + curr;
